import { Tooltip, Fab } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import React from 'react';

function ImpersonationOverlay() {
    return (
        <Tooltip title="Exit impersonation">
            <Fab
                color="secondary"
                onClick={() => {
                    // Get user being impersonated
                    const user = JSON.parse(localStorage.getItem('user'));
                    // Optional caller-provided return path (set by impersonate util)
                    const returnPath = localStorage.getItem('impersonating_return_path');
                    // Restore settings
                    localStorage.setItem('token', localStorage.getItem('token_backup'));
                    localStorage.setItem('settings', localStorage.getItem('settings_backup'));
                    localStorage.setItem('user', localStorage.getItem('user_backup'));
                    // Restore cross-tenant site override (if any) that impersonate set
                    if (localStorage.getItem('site_backup_was_unset') === 'true') {
                        localStorage.removeItem('site');
                    } else if (localStorage.getItem('site_backup') !== null) {
                        localStorage.setItem('site', localStorage.getItem('site_backup'));
                    }
                    localStorage.removeItem('site_backup');
                    localStorage.removeItem('site_backup_was_unset');
                    // Remove backups
                    localStorage.removeItem('token_backup');
                    localStorage.removeItem('settings_backup');
                    localStorage.removeItem('user_backup');
                    localStorage.removeItem('impersonating');
                    localStorage.removeItem('impersonating_return_path');
                    // Go back to the requested page, or the admin/user detail as a default
                    window.location.href = returnPath || `/admin/clientmanagement/users/${user.id}`
                }}
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    left: 16,
                    zIndex: 9999
                }}
            >
                <PersonIcon />
            </Fab>
        </Tooltip>
    );
}

export default ImpersonationOverlay;
